module.exports = __webpack_public_path__ + "static/media/display-tray-render.44e017c2.png";